export default function RulesLayout() {
  return <>regras</>
}
